require('./optionGroupRadioButtons.i18n.json');
require('./optionGroupRadioButtons.tpl.html');
require('./optionGroupRadioButtonsController.js');

const OptionGroupRadioButtonsComponent = {
    templateUrl: '/configuration/formEditor/content/form/componentSettings/optionGroup/optionGroupRadioButtons/optionGroupRadioButtons.tpl.html',
    controller: 'optionGroupRadioButtonsController',
    bindings: {
        selectedField: '<',
        name: '<',
        label: '<',
        groupName: '<',
        options: '<',
        value: '<',
        isDisabled: '<'
    }
};

angular.module('ums.configuration')
    .component('uiOptionGroupRadioButtons', OptionGroupRadioButtonsComponent);
